import './ApresentacaoInicial.css'
import bannerImage from '../../assets/imagem-principal.png'
import Button from '../../components/ButtonScroll';
export default function ApresentacaoInicial(){
    return(
        <div id='home' className='apresentacao'>
            <img src={bannerImage} className="banner" />
            <div className='areaTextoApresentacao'>
                <h1>Estruturas Metálicas</h1>
                <p>Soluções personalizadas e sob medida para cada projeto.</p>
                <Button targetId='portifolio'>Visualizar portifólio</Button>
            </div>
        </div>
    )
}